'use strict';

var _ = require('lodash');
var FlightLevelChartDirective = function FlightLevelChartDirective(Chart, dataProviderService, $timeout) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/flight-level-chart.html'),
    controller: 'FlightLevelChartController',
    scope: {
      mode: '@',
      screen: '@',
      screenState: '=',
      brushFilterType: '@'
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      scope.renderChartDataPresent = function (data) {
        var metric = dataProviderService.getSelectedMetric(scope.screen, scope.mode);
        chart.withMetric(metric).render(data);
        $timeout(function () {
          scope.$broadcast('perfect-scrollbar:update');
        }, 0);
      };
      chart.on('rangechangeend', function (brushRanges) {
        scope.ranges = brushRanges;
        scope.handleBrushEnd(true);
      });
      scope.$on('brush-filter:filterApplied', scope.onBrushFilter);
      scope.$on('flight-level-chart:reload', _.debounce(function (event, brushFilter) {
        scope.onBrushFilter(event, brushFilter, true);
      }, 100, {
        leading: true
      }));
      scope.setSelection = function (range) {
        chart.setInitialSelection(scope.calculateSelectionRanges(range));
      };
      scope.resetSelection = function () {
        scope.setSelection();
        scope.handleBrushEnd(true, true);
      };
      scope.$on(scope.screen + ':scenariosChanged', scope.onScenariosChanged);
      scope.$watch('screenState.dataRepresentation', function (dataRepresentation) {
        if (dataRepresentation) {
          scope.onDataRepresentationChange(dataRepresentation);
        }
      });
    }
  };
};
FlightLevelChartDirective.$inject = ['FlightLevelChart', 'FlightLevelChartDataProviderService', '$timeout'];
module.exports = FlightLevelChartDirective;